import { render } from "./MessageSection.vue?vue&type=template&id=d4acc50c"
import script from "./MessageSection.vue?vue&type=script&lang=js"
export * from "./MessageSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__